// eslint-disable-next-line max-classes-per-file
import { JsonElementType, JsonObject, JsonProperty } from 'ta-json';
import {
  GetCurrentUser_currentUser_roles,
  GetCurrentUser_currentUser_roles_children,
  GetCurrentUser_currentUser_roles_children_children,
  GetCurrentUser_currentUser_roles_permissions,
} from '@src/app/generated/GetCurrentUser';
import { Id, Scope } from '@ess/jg-rule-executor';
import { ToJsonInputTranslatable } from '@src/app/model/to-json-input-translatable';
import { UserInput } from '@src/app/generated/globalTypes';

@JsonObject()
export class User implements ToJsonInputTranslatable {
  @JsonProperty() id: Id<User>;
  @JsonProperty() email: string;
  @JsonProperty() totpQr: string | null;
  @JsonProperty() roles: Role[];
  @JsonProperty() blocked: boolean;
  @JsonProperty() scopes: Scope[];

  constructor(
    userId?: any,
    email?: string,
    totpQr?: string | null,
    roles: Role[] = [],
    blocked?: boolean,
    scopes: Scope[] = []
  ) {
    this.id = userId;
    this.email = email;
    this.totpQr = totpQr;
    this.roles = roles;
    this.blocked = blocked ?? false;
    this.scopes = scopes;
  }

  toGqlInput(): UserInput {
    return {
      allRoles: [],
      email: this.email ?? 'EMAIL',
      personalInformation: [],
      systemRoles: [],
      scopes: [],
    };
  }
}

@JsonObject()
export class Role {
  @JsonProperty() name: string;
  @JsonProperty() permissions: Permission[];
  @JsonProperty() children: Role[];
  @JsonProperty() deleted: boolean;

  constructor(name: string, permissions: Permission[], children: Role[], deleted: boolean) {
    this.name = name;
    this.permissions = permissions;
    this.children = children;
    this.deleted = deleted;
  }
}

@JsonObject()
export class Permission {
  @JsonProperty() bit: number;
  @JsonProperty() name: string;

  constructor(bit: number, name: string) {
    this.bit = bit;
    this.name = name;
  }
}

@JsonObject()
export class UserWithPermissions {
  @JsonProperty() user: User;
  @JsonProperty()
  @JsonElementType(Permission)
  permissions: Permission[];
}

export enum PermissionName {
  Read = 1,
  Update = 2,
  Delete = 4,
  Create = 8,
  All = Create | Read | Update | Delete
}

export function parseRoles(roles:
  GetCurrentUser_currentUser_roles[]
  | GetCurrentUser_currentUser_roles_children[]
  | GetCurrentUser_currentUser_roles_children_children[]
): Role[] {
  return roles.map(r => new Role(
    r.name,
    r?.permissions ? parsePermissions(r.permissions) : [],
    parseRoles(r.children) ?? [],
    r.deleted ?? false
  ));
}

function parsePermissions(permissions: GetCurrentUser_currentUser_roles_permissions[]): Permission[] {
  return permissions.map(p => new Permission(
    p.bit,
    p.name
  ));
}

export function getPermissions(roles: Role[]): Permission[] {
  const permissions: Permission[] = [];
  roles.map((r) => {
    if (r.children.length > 0) {
      permissions.push(...r.permissions, ...getPermissions(r.children));
    } else {
      permissions.push(...r.permissions);
    }
  });
  return permissions;
}
